import script from "./EmailTemplateDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailTemplateDetails.vue?vue&type=script&lang=ts&setup=true"

import "./EmailTemplateDetails.vue?vue&type=style&index=0&id=c9164c62&lang=scss"

const __exports__ = script;

export default __exports__